<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="formgrid grid">
        <div class="field col-12 md:col-12">
          <label>Divisi</label>
          <AutoComplete
            ref="divisi"
            v-model="selectedDivisi"
            placeholder="Search Divisi"
            :suggestions="listDivisi"
            field="name"
            class="w-full"
            input-class="w-full"
            :class="{ 'p-invalid': v$.selectedDivisi.$invalid && submitted }"
            @complete="searchDivisi"
            @item-select="onSelectDivisi"
            @focus="selectAllText('divisi')"
            @keydown="handleKeydownField($event, 'departemen')"
          >
            <template v-if="selectedDivisi" #selected-item>
              {{ selectedDivisi.name }}
            </template>
          </AutoComplete>
          <small
            v-if="
              (v$.selectedDivisi.$invalid && submitted) ||
              v$.selectedDivisi.$pending.$response
            "
            class="p-error"
            >{{ v$.selectedDivisi.required.$message }}</small
          >
        </div>
        <div class="field col-12 md:col-12">
          <label>Departemen</label>
          <AutoComplete
            ref="departemen"
            v-model="selectedDepartemen"
            placeholder="Search Departemen"
            :suggestions="listDepartemen"
            field="name"
            class="w-full"
            input-class="w-full"
            :class="{
              'p-invalid': v$.selectedDepartemen.$invalid && submitted,
            }"
            @complete="searchDepartemen"
            @item-select="onSelectDepartemen"
            @focus="selectAllText('departemen')"
            @keydown="handleKeydownField($event, 'subdepartemen')"
          >
            <template v-if="selectedDepartemen" #selected-item>
              {{ selectedDepartemen.name }}
            </template>
          </AutoComplete>
          <small
            v-if="
              (v$.selectedDepartemen.$invalid && submitted) ||
              v$.selectedDepartemen.$pending.$response
            "
            class="p-error"
            >{{ v$.selectedDepartemen.required.$message }}</small
          >
        </div>
        <div class="field col-12 md:col-12">
          <label>Sub Departemen</label>
          <AutoComplete
            ref="subdepartemen"
            v-model="selectedSubDepartemen"
            placeholder="Search Sub Departemen"
            :suggestions="listSubDepartemen"
            field="name"
            class="w-full"
            input-class="w-full"
            :class="{
              'p-invalid': v$.selectedSubDepartemen.$invalid && submitted,
            }"
            @complete="searchSubDepartemen"
            @item-select="onSelectSubDepartemen"
            @focus="selectAllText('subdepartemen')"
            @keydown="handleKeydownField($event, 'ctg')"
          >
            <template v-if="selectedSubDepartemen" #selected-item>
              {{ selectedSubDepartemen.name }}
            </template>
          </AutoComplete>
          <small
            v-if="
              (v$.selectedSubDepartemen.$invalid && submitted) ||
              v$.selectedSubDepartemen.$pending.$response
            "
            class="p-error"
            >{{ v$.selectedSubDepartemen.required.$message }}</small
          >
        </div>
        <div class="field col-12 md:col-12">
          <label>Kode Kategori (Opsional)</label>
          <InputText
            ref="ctg"
            v-model="form.ctg"
            type="text"
            class="w-full"
            maxlength="7"
            @keydown="handleKeydownField($event, 'name')"
          />
          <small
            v-if="
              this.editMode == true &&
              (this.form.ctg == '' || this.form.ctg == null)
            "
            class="p-error"
            >Kode kategori tidak boleh kosong</small
          >
          <small class="text-500">
            Kode otomatis dibuat sistem, tetapi masih dapat diubah.
          </small>
        </div>

        <div class="field col-12 md:col-12">
          <label>Nama Kategori</label>
          <InputText
            ref="name"
            v-model="form.name"
            :class="{ 'p-invalid': v$.form.name.$invalid && submitted }"
            type="text"
            class="w-full"
            maxlength="40"
            @keydown="handleKeydownField($event, 'std_mrg', true)"
          />
          <small
            v-if="
              (v$.form.name.$invalid && submitted) ||
              v$.form.name.$pending.$response
            "
            class="p-error"
            >{{ v$.form.name.required.$message }}</small
          >
        </div>
        <div class="field col-12 md:col-6">
          <label>STD Margin</label>
          <div class="p-inputgroup col-12 md:col-12" style="margin-left: -10px">
            <InputNumber
              ref="std_mrg"
              v-model="form.std_mrg"
              :class="{
                'p-invalid': v$.form.std_mrg.$invalid && submitted,
              }"
              :minFractionDigits="0"
              :maxFractionDigits="2"
              locale="id-ID"
              :min="0"
              :max="100"
              class="w-full"
              @keydown="handleKeydownField($event, 'btnSave')"
            />
            <span class="p-inputgroup-addon">%</span>
          </div>
          <small
            v-if="
              (v$.form.std_mrg.$invalid && submitted) ||
              v$.form.std_mrg.$pending.$response
            "
            class="p-error"
            >{{ v$.form.std_mrg.required.$message }}</small
          >
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          type="submit"
          ref="btnSave"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { focusNextField, handleKeydownField } from '@/helpers'
import errorHandler from '@/helpers/error-handler'
import DepartemenService from '@/services/DepartemenService'
import DivisiService from '@/services/DivisiService'
import KategoriService from '@/services/KategoriService'
import SubDepartemenService from '@/services/SubDepartemenService'
import useVuelidate from '@vuelidate/core'
import { helpers, numeric, required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  created() {
    this.divisiService = new DivisiService()
    this.departemenService = new DepartemenService()
    this.subdepartemenService = new SubDepartemenService()
    this.kategoriService = new KategoriService()
  },
  async mounted() {
    if (this.editMode) {
      if (this.form.div_id) {
        try {
          const divisiRes = await this.divisiService.getById(
            `/${this.form.div_id}`
          )
          this.selectedDivisi = divisiRes.data.data
        } catch (error) {
          errorHandler(error, 'Data Divisi', this)
        }
      }

      if (this.form.dept_id) {
        try {
          const departemenRes = await this.departemenService.getById(
            `/${this.form.dept_id}`
          )
          this.selectedDepartemen = departemenRes.data.data
        } catch (error) {
          errorHandler(error, 'Data Departemen', this)
        }
      }

      if (this.form.subdept_id) {
        try {
          const subDepartemenRes = await this.subdepartemenService.getById(
            `/${this.form.subdept_id}`
          )
          this.selectedSubDepartemen = subDepartemenRes.data.data
        } catch (error) {
          errorHandler(error, 'Data Sub Departemen', this)
        }
      }
    }
    this.$nextTick(() => {
      setTimeout(() => {
        focusNextField(this, 'divisi')
      }, 100)
    })
  },

  data() {
    return {
      submitted: false,
      divisiService: null,
      departemenService: null,
      subdepartemenService: null,
      selectedDivisi: [],
      selectedDepartemen: [],
      selectedSubDepartemen: [],
      listDivisi: [],
      listDepartemen: [],
      listSubDepartemen: [],
    }
  },
  computed: {
    form() {
      return this.item
    },
  },
  methods: {
    selectAllText(event) {
      if (event) {
        this.$refs[event].$el.querySelector('input').select()
      }
    },
    handleSubmit(isFormValid) {
      this.submitted = true
      if (
        this.editMode == true &&
        (this.form.ctg == '' || this.form.ctg == null)
      ) {
        return
      }

      if (!isFormValid) {
        return
      }

      this.$emit('save', this.form)
    },
    async searchDivisi(event) {
      const search = event.query
      await this.divisiService
        .getList(search)
        .then((res) => {
          this.listDivisi = res.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Divisi', this)
        })
    },
    onSelectDivisi() {
      if (!this.editMode) {
        this.selectedDepartemen = []
        this.selectedSubDepartemen = []
        this.form.dept_id = null
        this.form.subdept_id = null
      }
      if (this.selectedDivisi) {
        this.form.div_id = this.selectedDivisi.id
      }
    },
    async searchDepartemen(event) {
      const search = event.query
      await this.departemenService
        .getList(this.form.div_id, search)
        .then((res) => {
          this.listDepartemen = res.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Departemen', this)
        })
    },
    onSelectDepartemen() {
      if (!this.editMode) {
        this.selectedSubDepartemen = []
        this.form.subdept_id = null
      }
      if (this.selectedDepartemen) {
        this.form.dept_id = this.selectedDepartemen.id
      }
    },
    async searchSubDepartemen(event) {
      const search = event.query
      await this.subdepartemenService
        .getList(this.form.dept_id, search)
        .then((res) => {
          this.listSubDepartemen = res.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Sub Departemen', this)
        })
    },
    async onSelectSubDepartemen() {
      if (this.selectedSubDepartemen) {
        this.form.subdept_id = this.selectedSubDepartemen.id
        this.form.std_mrg = this.selectedSubDepartemen.std_mrg

        const selectedDivisi = this.listDivisi.find(
          (div) => div.id === this.form.div_id
        )

        const selectedDepartemen = this.listDepartemen.find(
          (dept) => dept.id === this.form.dept_id
        )

        const selectSubDepartemen = this.listSubDepartemen.find(
          (subdept) => subdept.id === this.form.subdept_id
        )

        this.form.parent_ref =
          selectedDivisi && selectedDepartemen && selectSubDepartemen
            ? `${selectedDivisi.ctg}-${selectedDepartemen.ctg}-${selectSubDepartemen.ctg}`
            : null

        const res = await this.kategoriService.generateCode(
          selectSubDepartemen.id
        )

        this.form.ctg = res.data.ctg
      }
    },
    handleKeydownField(event, nextRef, selectAll = false) {
      handleKeydownField(this, event, nextRef, selectAll)
    },

    focusNextField(refName, selectAll = false) {
      focusNextField(this, refName, selectAll)
    },
  },
  validations() {
    return {
      selectedDivisi: {
        required: helpers.withMessage('Divisi harus dipilih.', required),
      },
      selectedDepartemen: {
        required: helpers.withMessage('Departemen harus dipilih.', required),
      },
      selectedSubDepartemen: {
        required: helpers.withMessage(
          'Sub Departemen harus dipilih.',
          required
        ),
      },
      form: {
        subdept_id: {
          required: helpers.withMessage(
            'Sub Departemen harus dipilih.',
            required
          ),
        },
        name: {
          required: helpers.withMessage('Nama kategori harus diisi.', required),
        },
        std_mrg: {
          required: helpers.withMessage(
            'STD Margin harus diisi dengan angka',
            required
          ),
          numeric,
        },
      },
    }
  },
}
</script>
